import { NativeSelect, NativeSelectFieldProps } from '@chakra-ui/react';

import { FieldError } from '../field-error/field-error';
import { CommonFieldProps } from '../input/input';
import { Label } from '../label/label';

interface Option {
  label: string;
  value: string;
}

interface SelectProps extends CommonFieldProps {
  options: Option[];
  ref?: React.Ref<HTMLSelectElement>;
}

export const Select = ({
  errors,
  options,
  label,
  ref,
  ...props
}: SelectProps & NativeSelectFieldProps) => {
  const error = errors?.[props.name]?.message?.toString();

  return (
    <div>
      {label && (
        <Label mb={1} htmlFor={props.name}>
          {label}
        </Label>
      )}
      <NativeSelect.Root colorPalette="brand" rounded="md">
        <NativeSelect.Indicator />
        <NativeSelect.Field
          bg="white"
          cursor="pointer"
          ref={ref}
          borderColor={error ? 'red.500' : undefined}
          {...props}
        >
          {options.map((option: Option, index: number) => (
            <option key={`option-${index}`} value={option.value}>
              {option.label}
            </option>
          ))}
        </NativeSelect.Field>
      </NativeSelect.Root>
      <FieldError error={error} />
    </div>
  );
};
